import clsx from 'clsx'
import React from 'react'
export interface IDropdownListAction {
    title: string
    action: (value: any) => void
    icon: React.ReactNode
    type?: 'btn-drp-link' | 'btn-drp-link-danger'
    hidden?: boolean
}
interface IDropdownList {
    list: IDropdownListAction[]
}
const DropdownList = ({ list }: IDropdownList) => {
    return (
        <ul className="dropdown-list-links">
            {list.map((el, index) => (
                <li
                    key={index}
                    className={`dropdown-list-link ${el.hidden ? 'hidden' : ''}`}
                >
                    <button
                        type="button"
                        className={clsx(
                            'btn btn--md  text-left  justify-start',
                            {
                                [el.type || 'btn-drp-link']: true,
                            },
                        )}
                        onClick={el.action}
                    >
                        <span className="ico">{el.icon}</span>
                        <span>{el.title}</span>
                    </button>
                </li>
            ))}
        </ul>
    )
}

export default DropdownList
